import { IOrderFrequency, isSingletonFrequency } from '@/types/order';
import { ClickEvent } from '@/utils/clickEvent';
import { Repeat, RepeatOne } from '@mui/icons-material';

import { AxleChip } from '../displayFields/chips';
import { renderOrderFrequency1xStyle } from './labels';

// The frequency pill used in order cells (e.g. "2x weekly for 5 weeks"), shared
// so the create-visit frequency rows match the visits table treatment.
export const OrderFrequencyChip = ({
    frequency,
    tooltip,
    routerLink,
    onClick,
    thin,
}: {
    frequency: IOrderFrequency;
    tooltip?: string;
    routerLink?: string;
    onClick?: (event: ClickEvent) => void;
    thin?: boolean;
}) => (
    <AxleChip
        icon={isSingletonFrequency(frequency) ? <RepeatOne /> : <Repeat />}
        label={renderOrderFrequency1xStyle({ frequency, withIntervals: true })}
        tooltip={tooltip}
        routerLink={routerLink}
        onClick={onClick}
        thin={thin}
    />
);
